<p *ifPrivilege="{name: 'write', value: 'dynamic-content-entrances'}">
  <button (click)="updateOrCreateDynamicContent()" color="primary" mat-raised-button>Create new entrance</button>
</p>

<ng-container *ifPrivilege="{name: 'read', value: 'dynamic-content-entrances'}">
  <div class="available">
    <h3>Available</h3>
    <data-table
      #dynamicContentTable
      (detail)="detail($event)"
      (edit)="edit($event)"
      (remove)="remove($event)"
      [columns]="columns"
      [dataProvider]="assignedContentEntranceService">
    </data-table>
  </div>
</ng-container>
